export default function isEnumValue<EnumValue extends string>(
  enumObject: Record<string, EnumValue>,
  value: string,
): value is EnumValue {
  return Object.values<string>(enumObject).includes(value);
}
